import '@js/app-supply'
import '@js/app-proto'

if(process.browser) {
    require('@js/app');
}